module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"type":"@:labels.type","unit":"Use percentage","total":"@:labels.total"},"fr":{"type":"@:labels.type","unit":"Utiliser un pourcentage","total":"@:labels.total"}}')
  delete Component.options._Ctor
}
